import { formatDate } from '@/web-task/filter.js'
import { getInsuranceType } from '../../utils'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, setting } = this

	let arr = [
		{
			label: '派单公司',
			value: order.company,
		},
		{
			label: '所属险种',
			value: getInsuranceType(setting, order),
		},
		{
			label: '报案号',
			value: order.caseNo,
		},
		{
			label: '服务公司',
			value: order.serviceCompanyName,
		},
		{
			label: '订单号',
			value: order.orderNo,
		},
		{
			label: '任务类型',
			value: setting.conciliationTasktypeMap[order.taskType],
		},
		// {
		// 	label: '订单类型',
		// 	value: setting.orderTypeMap[order.orderType],
		// },
		{
			label: '车主姓名',
			value: order.ownerName,
		},
		{
			label: '车主电话',
			value: order.ownerPhone,
		},
	]
	arr.push(
		{
			label: '调解地区',
			value: order.clinicArea,
		},
		{
			label: '案发时间',
			value: formatDate(order.accidentDate),
		},
		{
			label: '案发地点',
			value: order.address,
		}
	)
	arr = arr.concat([
		{
			label: '案件负责人姓名',
			value: order.contact,
		},
		{
			label: '案件负责人电话',
			value: order.contactPhone,
		},
	])
	arr.push({
		label: '任务要求',
		value: order.visitRequest,
	})
	if (order.cancelReason) {
		arr.push({
			label: '撤单原因',
			value: order.cancelReason,
		})
	}
	return {
		title: '任务信息',
		children: arr,
	}
}
